// Frontend JavaScript to handle parallax effect
export function initParallaxEffect() {
    console.log('Initializing parallax effect');
    const parallaxElements = document.querySelectorAll('.figport-parallax');
    console.log('Found parallax elements:', parallaxElements.length);

    function handleScroll() {
        const scrollY = window.pageYOffset;
        parallaxElements.forEach((element) => {
            const speed = parseFloat(element.getAttribute('data-parallax-speed'));
            const yPos = -(scrollY * speed);
            element.style.transform = `translateY(${yPos}px)`;
        });
    }

    window.addEventListener('scroll', handleScroll);

    // For the editor, we need to trigger the effect on block selection
    if (window.wp && window.wp.data) {
        const { subscribe } = window.wp.data;
        subscribe(() => {
            const selectedBlock = window.wp.data.select('core/block-editor').getSelectedBlock();
            if (selectedBlock && selectedBlock.name === 'figport/custom-block') {
                handleScroll();
            }
        });
    }
}

// Run the initialization when the DOM is ready
if (typeof window !== 'undefined') {
    console.log('Adding DOMContentLoaded event listener');
    window.addEventListener('DOMContentLoaded', initParallaxEffect);
    window.addEventListener('load', initParallaxEffect);
}